import * as React from 'react'

import {
  Text,
  Breakpoints,
  InlineChildren,
  StackChildren,
} from '@doordash/design-language'
import * as CONSTANT from './constants'
import {
  CitiesContainer,
  TopCitiesContainer,
  TopCitiesTitle,
  TopCitiesTitleContainer,
} from './styles'

import MediaQuery from 'react-responsive'

import CityList from '../../atoms/driving-opportunities-city-jobs'

const DrivingOpportunitiesTopCities: React.SFC<{}> = () => (
  <TopCitiesContainer>
    <StackChildren>
      <TopCitiesTitleContainer>
        <TopCitiesTitle styles={Text.Styles.PageTitle}>
          {CONSTANT.TOP_CITIES_TITLE}
        </TopCitiesTitle>
      </TopCitiesTitleContainer>

      <MediaQuery minWidth={Breakpoints.Desktop + 1}>
        <CitiesContainer
          justifyContent={InlineChildren.Justification.SpaceBetween}
          mobile={false}
        >
          <CityList cityTitle={CONSTANT.TITLE_1} slug={CONSTANT.SLUG_1} />
          <CityList cityTitle={CONSTANT.TITLE_2} slug={CONSTANT.SLUG_2} />
          <CityList cityTitle={CONSTANT.TITLE_3} slug={CONSTANT.SLUG_3} />
          <CityList cityTitle={CONSTANT.TITLE_4} slug={CONSTANT.SLUG_4} />
        </CitiesContainer>
        <CitiesContainer
          justifyContent={InlineChildren.Justification.SpaceBetween}
          mobile={false}
        >
          <CityList cityTitle={CONSTANT.TITLE_5} slug={CONSTANT.SLUG_5} />
          <CityList cityTitle={CONSTANT.TITLE_6} slug={CONSTANT.SLUG_6} />
          <CityList cityTitle={CONSTANT.TITLE_7} slug={CONSTANT.SLUG_7} />
          <CityList cityTitle={CONSTANT.TITLE_8} slug={CONSTANT.SLUG_8} />
        </CitiesContainer>
      </MediaQuery>

      <MediaQuery maxWidth={Breakpoints.Desktop}>
        <CitiesContainer
          justifyContent={InlineChildren.Justification.SpaceAround}
          mobile={true}
        >
          <CityList cityTitle={CONSTANT.TITLE_1} slug={CONSTANT.SLUG_1} />
          <CityList cityTitle={CONSTANT.TITLE_2} slug={CONSTANT.SLUG_2} />
        </CitiesContainer>
        <CitiesContainer
          justifyContent={InlineChildren.Justification.SpaceAround}
          mobile={true}
        >
          <CityList cityTitle={CONSTANT.TITLE_3} slug={CONSTANT.SLUG_3} />
          <CityList cityTitle={CONSTANT.TITLE_4} slug={CONSTANT.SLUG_4} />
        </CitiesContainer>
        <CitiesContainer
          justifyContent={InlineChildren.Justification.SpaceAround}
          mobile={true}
        >
          <CityList cityTitle={CONSTANT.TITLE_5} slug={CONSTANT.SLUG_5} />
          <CityList cityTitle={CONSTANT.TITLE_6} slug={CONSTANT.SLUG_6} />
        </CitiesContainer>
        <CitiesContainer
          justifyContent={InlineChildren.Justification.SpaceAround}
          mobile={true}
        >
          <CityList cityTitle={CONSTANT.TITLE_7} slug={CONSTANT.SLUG_7} />
          <CityList cityTitle={CONSTANT.TITLE_8} slug={CONSTANT.SLUG_8} />
        </CitiesContainer>
      </MediaQuery>
    </StackChildren>
  </TopCitiesContainer>
)

export default DrivingOpportunitiesTopCities
